import React, { Component } from 'react';

// 画像読み込み
import nav_1 from '../img/nav_1.png'
import nav_2 from '../img/nav_2.png'
import nav_3 from '../img/nav_3.png'
import nav_4 from '../img/nav_4.png'

class Navigation extends Component {
  render() {
    return (
      <div className="Navigation">
        <div className="Navigation-box">
          <div>1. 検索ページにて，現在地を取得し近くの観光スポットを表示します．未訪問のスポットは赤色のピン，訪問済みのスポットは緑色のピンで表示されます．</div>
          <img src={nav_1} alt="" />
        </div>
        <div className="Navigation-box">
          <div>2. 訪問したスポットはチェックボックスにチェックしましょう</div>
          <img src={nav_2} alt="" />
        </div>
        <div className="Navigation-box">
          <div>3. チェックしたらピンが緑色に変化しました</div>
          <img src={nav_3} alt="" />
        </div>
        <div className="Navigation-box">
          <div>4. 訪問済みのスポット一覧はマイページから確認することが出来ます</div>
          <img src={nav_4} alt="" />
        </div>
      </div>
    )
  }
}

export default Navigation;
